// 20.1.2.3 Number.isInteger(number)
var isObject = require('./$.is-object')
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.is-integer.js
 ** module id = 446
 ** module chunks = 1
 **/